import { Component } from "preact";
import classNames from "classnames";
import styles from "./Header.css";

export default class Header extends Component {

	render(props, state, ctx) {
		return (
			<header class={classNames(styles.Header)}>
				<h1 style={{fontSize: 36, marginBottom: 10}}>Welcome to Stonegate Dental Practice</h1>
				<p className={classNames("lead", styles.TagLine)}>
					Proud to offer high quality private dentistry in the Meanwood area.
				</p>
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./components/Header/Header.js